import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

import {ref, watch} from "vue";
import {useRoute} from "vue-router";
import {storeToRefs} from "pinia";
import {useAccountStore} from "@/stores/accountStore";
import {ApiApiStatus} from "@/shared/services/apiStatus";


export default /*@__PURE__*/_defineComponent({
  __name: 'ApiStatusBannerComponent',
  setup(__props) {

const _route = useRoute()
const {authenticated} = storeToRefs(useAccountStore())

const _messages = ref<string[]>([])

async function load() {
  if (!authenticated.value) {
    _messages.value = []
    return
  }
  const status = await new ApiApiStatus().load()
  const messages: string[] = []
  if (status?.purchaseBlocked && status.purchaseMessage) {
    messages.push(status.purchaseMessage)
  }
  if (status?.evbGenerationBlocked && status.evbGenerationMessage) {
    messages.push(status.evbGenerationMessage)
  }
  _messages.value = [...new Set(messages)]
}

// beim Anmelden und bei jedem Seitenwechsel neu laden, damit Änderungen in der Config ohne Reload sichtbar werden
watch([authenticated, () => _route.fullPath], load, {immediate: true})

return (_ctx: any,_cache: any) => {
  return (_messages.value.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_messages.value, (message) => {
          return (_openBlock(), _createElementBlock("div", {
            key: message,
            class: "api-status-banner",
            role: "alert"
          }, [
            _cache[0] || (_cache[0] = _createElementVNode("span", { class: "mdi mdi-alert-outline" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(message), 1)
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})